import { render, staticRenderFns } from "./ViewActionReview.vue?vue&type=template&id=6403d578&"
import script from "./ViewActionReview.vue?vue&type=script&lang=js&"
export * from "./ViewActionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports